import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { IPage, DonatePageState } from 'store/donatePage/types';

export const getDonatePageState = (state: RootState): DonatePageState => state.donatePage;

export const getDonatePageData = createSelector(
  [getDonatePageState],
  (state: DonatePageState): IPage | undefined => state.data
);

export const getDonationAmounts = createSelector(
  [getDonatePageState],
  (state: DonatePageState): number[] => state?.data?.donation_amounts || [10, 25, 50, 100]
);
